import { createFileRoute } from "@tanstack/react-router";
import PoliciesForm from "../pages/PoliciesForm/PoliciesForm";
import { WORKFORCE_TAB } from "../constants/policies.constants";

export const Route = createFileRoute("/_policies/new-policy")({
  validateSearch: (search: Record<string, unknown>) => ({
    category: (search.category as string | undefined) ?? WORKFORCE_TAB,
  }),
  component: NewPolicyPage,
});

function NewPolicyPage() {
  return <PoliciesForm actionType="new" />;
}
